import { FunctionComponent } from 'react';
import { Prompt } from '@tv2-dal/offspring/prompts/components/Prompt';
import { AntiSharing } from '@tv2-dal/offspring/anti-sharing/components/AntiSharing';
import { useCurrentProfile } from '@/api/user/ProfileProvider';
import InfoBox from '@/components/messages/InfoBox/InfoBox';
import { useUser } from '@tv2/lib-offspring/api/user/UserProvider';

export const PageOverlays: FunctionComponent = () => {
  const { isParentalControlled, completed, profile, shouldRedirect } = useCurrentProfile();
  const { user } = useUser();

  return (
    <>
      {user && <AntiSharing user={user} />}
      {!isParentalControlled && completed && profile && !shouldRedirect ? (
        <Prompt>
          <InfoBox />
        </Prompt>
      ) : null}
    </>
  );
};
